<script>
import ModalKnowledgeAreaComponent from '../../features/modals/ModalKnowledgeAreaComponent';
export default {
  name: 'ModalKnowledgeAreaView',
  extends: ModalKnowledgeAreaComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Area de Conocimiento"
    width="30%"
    class="knowledge-area-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Carrera</legend>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Código"
              prop="code"
            >
              <el-input
                v-model="formData.code"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Nombre"
              prop="name"
            >
              <el-input
                v-model="formData.name"
                maxlength="70"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Descripción"
              prop="description"
            >
              <el-input
                v-model="formData.description"
                type="textarea"
                :row="3"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
          >
            <el-form-item
              label="Universidad"
              prop="university"
            >
              <el-select
                v-model="formData.university"
                clearable
                filterable
                remote
                :remote-method="onFindUniversity"
                placeholder="Seleccionar"
                value-key="id"
                size="small"
                @focus="onFocus"
              >
                <el-option
                  v-for="item in universities"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>